"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiRefillRepo = createApiRefillRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const ItemList_1 = require("../../../common/models/ItemList");
const RefillMapper_1 = require("./mappers/RefillMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiRefillRepo() {
    return {
        getAll,
        getById,
    };
}
async function getAll(page = 1, pageSize = 10, machineId = '', startDate = '', endDate = '') {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/refills`),
            params: {
                startDate,
                endDate,
                page,
                pageSize,
                machineId,
            },
        });
        const refillList = {
            items: res.refills.map(RefillMapper_1.mapToDomainRefill),
            pagination: res.pagination,
        };
        (0, http_helpers_1.sendSuccessStatus)();
        return refillList;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function getById(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/refills/${id}`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return (0, RefillMapper_1.mapToDomainRefillDetail)(res);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return {};
    }
}
